import request from "@/utils/oms-request";
import { AxiosPromise } from "axios";

export const searchProductNumber = (params: any, productId: string) =>
  request({
    url: "/product_numbers/" + productId,
    method: "get",
    params
  });
// 获取华强编号 /product_numbers/hq/{id}
export const searchHqProductNumber = (params: any, productId: string) =>
  request({
    url: "/product_numbers/hq/" + productId,
    method: "get",
    params
  });

export interface ProductNumberType {
  numberTypeId: string;
  name: string;
  code: string;
  description: string;
  weight: number;
}

export const searchProductNumberType = (): AxiosPromise =>
  request({
    url: "/number_types",
    method: "get"
  });
export const searchHqProductNumberType = (): AxiosPromise =>
  request({
    url: "/hq-transaction-number/search",
    method: "get"
  });
export const saveNumberType = (data: ProductNumberType) =>
  request({
    url: "/number_types",
    method: "post",
    data
  });
export const saveHqNumberType = (data: ProductNumberType) =>
  request({
    url: "/hq-transaction-number/insert",
    method: "post",
    data
  });
export const updateHqNumberType = (id: string, data: ProductNumberType) =>
  request({
    url: "/hq-transaction-number/" + id,
    method: "put",
    data
  });
export const getHqNumberType = (id: string) =>
  request({
    url: "/hq-transaction-number/" + id,
    method: "get",
  });
export const deleteHqNumberType = (id: string) =>
  request({
    url: "/hq-transaction-number/" + id,
    method: "delete",
  });


export interface ProductNumberUnit {
  id: string;
  referenceType: string;
  referenceTypeId: string;
  referenceNumber: string;
}

export const getNumberUnit = (numberId: string, params: any) =>
  request({
    url: "/product_numbers/units/" + numberId,
    method: "get",
    params
  });
export const getHqNumberUnit = (numberId: string, params: any) =>
  request({
    url: "/product_numbers/units/hq/" + numberId,
    method: "get",
    params
  });

export const saveNumberUnit = (numberId: string, data: any) =>
  request({
    url: "/product_numbers/units/" + numberId,
    method: "post",
    data
  });

export const migrateUnit = (data: any) =>
  request({
    url: "/product_numbers/units/migrate",
    method: "post",
    data
  });

export const countNumberUnit = (numberId: string) =>
  request({
    url: "/product_numbers/count_unit/" + numberId,
    method: "get"
  });

interface ProductNumberMigrationReq {
  oldNumberIds: string[];
  newNumberId: string;
}

export const migrateNumber = (type: string, data: ProductNumberMigrationReq) =>
  request({
    url: "/product_numbers/migrate/" + type,
    method: "post",
    data
  });

export const uploadSn = (productId: string, data: any) =>
  request({
    headers: { "Content-Type": "multipart/form-data" },
    url: "/product_numbers/upload/" + productId,
    method: "post",
    data: data
  });
export const uploadSnResult = (productId: string, data: any) =>
  request({
    headers: { "Content-Type": "multipart/form-data" },
    url: "/product_numbers/save_match/" + productId,
    method: "post",
    data: data
  });
export const getSnResult = (productId: string) =>
  request({
    url: "/product_numbers/match/" + productId,
    responseType: "blob",
    method: "get"
  });
export const exportSn = (productId: string) =>
  request({
    url: "/product_numbers/export/" + productId,
    responseType: "blob",
    method: "get"
  });
export const exportNoSn = (productId: string) =>
  request({
    url: "/product_numbers/export_unit/" + productId,
    responseType: "blob",
    method: "get"
  });
export const deletedSn = (id: string) =>
  request({
    url: "/product_numbers/" + id,
    method: "delete"
  });
// /product_numbers/{id}/extend
export const getExtend = (id: any) =>
  request({
    url: `/product_numbers/${id}/extend`,
    method: "get"
  });
// /product_numbers/{id}/extend
export const putExtend = (id: any,data) =>
  request({
    url: `/product_numbers/${id}/extend`,
    method: "put",
    data
  });
